import { createServerFn } from "@tanstack/react-start";
import { useAppSession } from "@/utils/session";

export const logout = createServerFn({ method: "POST" }).handler(async () => {
  const session = await useAppSession();
  await session.clear();
});
